import useReveal from "../hooks/useReveal";
import Header from "../components/arvi/Header";
import Hero from "../components/arvi/Hero";
import BrandStory from "../components/arvi/BrandStory";
import Manifesto from "../components/arvi/Manifesto";
import Collections from "../components/arvi/Collections";
import Showcase from "../components/arvi/Showcase";
import Craftsmanship from "../components/arvi/Craftsmanship";
import Pricing from "../components/arvi/Pricing";
import Configurator from "../components/arvi/Configurator";
import Process from "../components/arvi/Process";
import WhyChooseUs from "../components/arvi/WhyChooseUs";
import Testimonials from "../components/arvi/Testimonials";
import FinalCTA from "../components/arvi/FinalCTA";
import Footer from "../components/arvi/Footer";
import FloatingWhatsApp from "../components/arvi/FloatingWhatsApp";
import MobileStickyBar from "../components/arvi/MobileStickyBar";

export default function Home() {
  useReveal();
  return (
    <div data-testid="home-page" className="bg-ivory text-maroon pb-16 md:pb-0">
      <Header />
      <main>
        <Hero />
        <BrandStory />
        <Manifesto />
        <Collections />
        {/* <Showcase /> */}
        <Craftsmanship />
        <Pricing />
        <Configurator />
        <Process />
        <WhyChooseUs />
        {/* <Testimonials /> */}
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileStickyBar />
    </div>
  );
}
